import React from "react";
import AnnualAwardSummaryTable from "./AnnualAwardSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const AnnualAwardSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={AnnualAwardSummaryTable}
    loadingMessage="Loading annual awards summary..."
  />
);

export default AnnualAwardSummaryIndex;
